
export default {
  name: "Printing",
  data() {
    return {
      imgArray: [1, 1, 1, 1, 1],
    };
  },
};
